import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';

interface CampaignAverageProps {
  className?: string;
  title?: ReactNode;
}

export const CampaignAverage = ({ title, className }: CampaignAverageProps) => {
  const { t } = useTranslation();

  return <div className={cn('average-cell', className)}>{title || t('Average')}</div>;
};
